/**
 * Тип оплаты
 * - byRateOfCentralBank: по курсу ЦБ (платим в валюте сделки)
 * - byCustomRate: произвольный курс (платим в локальной валюте)
 * - byDocumentExactly: в точности по документу основания
 * - direct: прямой платёж (валюта сделки = локальная валюта)
 */
export type PaymentTypeId = 'byRateOfCentralBank' | 'byCustomRate' | 'byDocumentExactly' | 'direct';

class PaymentType {
    public id: PaymentTypeId;
    public name: string;

    constructor(id: PaymentTypeId, name: string) {
        this.id = id;
        this.name = name;
    }

    static readonly BY_RATE_OF_CENTRAL_BANK = new PaymentType('byRateOfCentralBank', 'По курсу ЦБ');
    static readonly BY_CUSTOM_RATE =          new PaymentType('byCustomRate', 'Произвольный курс');
    static readonly BY_DOCUMENT_EXACTLY =     new PaymentType('byDocumentExactly', 'В точности по документу основания');
    static readonly DIRECT =                  new PaymentType('direct', 'Прямой');

    static all(): PaymentType[] {
        return [
            PaymentType.BY_RATE_OF_CENTRAL_BANK,
            PaymentType.BY_CUSTOM_RATE,
            PaymentType.BY_DOCUMENT_EXACTLY,
            PaymentType.DIRECT,
        ];
    }

    static fromId(id: PaymentTypeId): PaymentType | undefined {
        return this.all().find(type => type.id === id);
    }

    static fromServer(data: any): PaymentType {
        return new PaymentType(data.id, data.name);
    }

    /** Требуется ли ввод курса вручную */
    get requiresManualRate(): boolean {
        return this.id === 'byCustomRate';
    }

    /** Курс фиксирован (= 1) */
    get hasFixedRate(): boolean {
        return this.id === 'byRateOfCentralBank' || this.id === 'direct';
    }
}

export default PaymentType;